/**
 * Cart free gift — auto-add products when cart total exceeds theme threshold.
 * Settings (Theme settings → Cart → Free gift):
 *   product_selector, product_selector_2, gift_threhold_amount
 * Globals from theme.liquid:
 *   free_product_variant_id, second_free_product_variant_id, gift_threhold_amount (cents)
 *
 * Live used a MutationObserver on [data-subtotal] only. Impulse updates that node,
 * but Product Hero ATC + complimentary gift rebuild the drawer asynchronously —
 * so we also run on ajaxProduct:added / cart:build (same add/remove rules as live).
 */
$(document).ready(function () {
  var syncing = false;
  var debounceTimer = null;

  function refreshCartUi(product) {
    if ($('.cart__page').length > 0) {
      location.reload();
    } else {
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: { product: product },
        })
      );
    }
  }

  function addProductDiscovery() {
    if (!free_product_variant_id && !second_free_product_variant_id) return;
    syncing = true;
    $.ajax({
      type: 'post',
      url:
        '/cart/update.js?updates[' +
        free_product_variant_id +
        ']=1&updates[' +
        second_free_product_variant_id +
        ']=1',
      dataType: 'json',
      success: function (product) {
        syncing = false;
        refreshCartUi(product);
      },
      error: function () {
        syncing = false;
      },
    });
  }

  function removeProductDiscovery() {
    if (!free_product_variant_id && !second_free_product_variant_id) return;
    syncing = true;
    $.ajax({
      type: 'post',
      url:
        '/cart/update.js?updates[' +
        free_product_variant_id +
        ']=0&updates[' +
        second_free_product_variant_id +
        ']=0',
      dataType: 'json',
      success: function (product) {
        syncing = false;
        refreshCartUi(product);
      },
      error: function () {
        syncing = false;
      },
    });
  }

  function manageDiscoveryGift() {
    if (syncing) return;
    if (
      typeof gift_threhold_amount === 'undefined' ||
      gift_threhold_amount === '' ||
      isNaN(gift_threhold_amount)
    ) {
      return;
    }

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var total_price = cart.total_price;
        if (cart.item_count > 0) {
          if (total_price > 0) {
            if (total_price > gift_threhold_amount) {
              for (var id = 0; id < cart.items.length; id++) {
                var cart_item = cart.items[id];
                if (
                  String(cart_item.variant_id) === String(free_product_variant_id) ||
                  String(cart_item.variant_id) === String(second_free_product_variant_id)
                ) {
                  return false;
                }
              }

              if (free_product_variant_id !== '' || second_free_product_variant_id !== '') {
                addProductDiscovery();
              }
            } else {
              var free_product_variant_available_in_cart = false;
              var second_free_product_variant_available_in_cart = false;
              for (var i = 0; i < cart.item_count; i++) {
                if (String(cart.items[i].variant_id) === String(free_product_variant_id)) {
                  free_product_variant_available_in_cart = true;
                  break;
                }

                if (String(cart.items[i].variant_id) === String(second_free_product_variant_id)) {
                  second_free_product_variant_available_in_cart = true;
                  break;
                }
              }
              if (
                free_product_variant_available_in_cart === true ||
                second_free_product_variant_available_in_cart === true
              ) {
                removeProductDiscovery();
              }
            }
          } else {
            $.ajax({
              type: 'post',
              url: '/cart/clear.js',
              dataType: 'json',
              success: function (product) {
                refreshCartUi(product);
              },
              error: function () {},
            });
          }
        }
      })
      .catch(function () {});
  }

  function scheduleManageGift() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      manageDiscoveryGift();
    }, 500);
  }

  function bindSubtotalObserver() {
    var cartItems;
    if ($('.cart__page').length > 0) {
      cartItems =
        document.querySelector('.custom-subtotal [data-subtotal]') ||
        document.querySelector('[data-subtotal]');
    } else {
      cartItems = document.querySelector('[data-subtotal]');
    }
    if (!cartItems || cartItems.dataset.vgFreeGiftObserved === '1') return;
    cartItems.dataset.vgFreeGiftObserved = '1';
    new MutationObserver(function (mutationsList) {
      for (var i = 0; i < mutationsList.length; i++) {
        if (mutationsList[i].type === 'childList') {
          scheduleManageGift();
          break;
        }
      }
    }).observe(cartItems, { childList: true });
  }

  bindSubtotalObserver();

  /* Product Hero / drawer rebuild — live observer alone often misses this */
  document.addEventListener('ajaxProduct:added', function () {
    bindSubtotalObserver();
    scheduleManageGift();
  });
  document.addEventListener('cart:build', function () {
    bindSubtotalObserver();
    scheduleManageGift();
  });

  if ($('.cart__page').length > 0) {
    manageDiscoveryGift();
  }
});
